import {
    WALLET_TOKEN_COUNT_ERROR,
    WALLET_TOKEN_COUNT_LOAD,
    WALLET_TOKEN_COUNT_SUCCESS,
    WALLET_TOKEN_ERROR,
    WALLET_TOKEN_SUBMIT,
    WALLET_TOKEN_SUCCESS,
    WALLET_GET_TOKEN_ERROR,
    WALLET_GET_TOKEN_LOAD,
    WALLET_GET_TOKEN_SUCCESS,
    WALLET_TOKEN_REQUEST_ERROR,
    WALLET_TOKEN_REQUEST_LOAD,
    WALLET_TOKEN_REQUEST_SUCCESS,
    WALLET_TOKEN_YIELDFEE_ERROR,
    WALLET_TOKEN_YIELDFEE_LOAD,
    WALLET_TOKEN_YIELDFEE_SUCCESS
} from '../actionTypes'

const initialState = {
    isLoading: false,
    tokens: 0,
    isSubmit: false,
    success: false,
    message: '',
    completeToken: 0,
    tvlHistory: [],
    taxa: 0,
    chart: {},
    rewards: [],
    isLoadingRewards: false,
    totalRewards: 0,
    chartFLWT: {},
    tokensMonth: 0,
    tokensApprovals: 0,
    vendasTokens: [],
    fee: 0
}

export default (state = initialState, action) => {
    switch(action.type) {
        case WALLET_TOKEN_COUNT_ERROR:
            return {
                ...state,
                isLoading: false,
            }
        case WALLET_TOKEN_COUNT_LOAD:
            return {
                ...state,
                isLoading: true,
            }
        case WALLET_TOKEN_COUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tokens: action.payload.tokens
            }

        case WALLET_TOKEN_ERROR:
            return {
                ...state,
                success: false,
                message: action.payload.message,
                isSubmit: false,
            }

        case WALLET_TOKEN_SUBMIT:
            return {
                ...state,
                isSubmit: true,
                message: '',
                success: false
                
            }

        case WALLET_TOKEN_SUCCESS:
            return {
                ...state,
                isSubmit: false,
                success: true,
                message: 'Tokens comprados',
                completeToken: true
            }
        
        case WALLET_GET_TOKEN_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case WALLET_GET_TOKEN_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false
            }

        case WALLET_GET_TOKEN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                tvlHistory: action.payload.tvlHistory,
                taxa: action.payload.taxa[0]['taxaAnual'],
                chart: action.payload.chart,
                rewards: action.payload.dtWallet,
                totalRewards: action.payload.totalRewards,
                chartFLWT: action.payload.chartW,
                tokensMonth: action.payload.tokensMonth,
                tokensApprovals: action.payload.tokensApprovals
            }

        case WALLET_TOKEN_REQUEST_LOAD:
            return {
                ...state,
                isLoading: true,
            }

        case WALLET_TOKEN_REQUEST_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false
            }

        case WALLET_TOKEN_REQUEST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                vendasTokens: action.payload.vendas
            }  
            
        case WALLET_TOKEN_YIELDFEE_LOAD:
            return {
                ...state,
                isLoading: true,
            }
    
        case WALLET_TOKEN_YIELDFEE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false
            }
    
        case WALLET_TOKEN_YIELDFEE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                fee: action.payload.fee
            }

        default:
            return state
    }
}